import React from "react";
import {
  getCommunityDisplayName,
  getCommunityLogoUrl
} from "../../services/auth";

const Community = React.memo(({ community, onClick }) => {
  return (
    <div className="sc__community cell small-4" onClick={onClick}>
      <div className="sc__community-logo">
        <img src={getCommunityLogoUrl(community)} alt={community.name} />
      </div>
      <span className="sc__community-name" title={community.name}>
        {getCommunityDisplayName(community)}
      </span>
    </div>
  );
});

export default Community;


// WEBPACK FOOTER //
// ./app/components/SelectCommunity/Community.js